export const routes = {
  expedition: {
    path: "/expedition",
    name: "expedition",
  },
  startExpedition: {
    path: "/start-expedition",
    name: "startExpedition",
  },
  packingWithLabel: {
    path: "/packing-with-label",
    name: "packingWithLabel",
  },
  confirmationExpedition: {
    path: "/expedition/confirmation",
    name: "confirmationExpedition",
  },
  transportsList: {
    path: "/transports-list",
    name: "transportsList",
  },
};
